import { encode } from 'gpt-tokenizer';

/**
 * Estimates the number of tokens in a given text string.
 * Uses gpt-tokenizer (BPE, GPT-4 compatible) as the primary method,
 * falling back to a character-based approximation if encoding fails.
 */
export function estimateTokens(text: string): number {
  if (!text) return 0;
  try {
    return encode(text).length;
  } catch {
    // Fallback: ~1 token per 4 characters (conservative approximation)
    return Math.ceil(text.length / 4);
  }
}
